import { SynqlyAuth } from '@synqly/ui/pages/auth'
import { authConfig } from '../api/auth/[...management-auth]'

export { AuthPage as default, getServerSideProps }

const { AuthPage, getServerSideProps } = SynqlyAuth({
  ...authConfig,
  callbackUrl: '/prod',
})
